module.exports = __webpack_public_path__ + "img/twitter.1cf43cb1.svg";